export const KMF_REFERENCE_DATA = 'kaMetlhaFuneralCover/referenceData/';

// Service Actions
export const KMF_REFERENCE_DATA_SERVICE = KMF_REFERENCE_DATA + 'service/';

export const GET_BANKS_REFERENCE_DATA_VALUE = KMF_REFERENCE_DATA_SERVICE + 'getValue/banks';
export const GET_BRANCH_CODES_REFERENCE_DATA_VALUE = KMF_REFERENCE_DATA_SERVICE + 'getValue/branchCodes';
export const GET_AGENT_REFERENCE_DATA_VALUE = KMF_REFERENCE_DATA_SERVICE +'getValue/agentCodes';
export const getBanksReferenceDataService = () => ({ type: GET_BANKS_REFERENCE_DATA_VALUE });
export const getBranchCodesReferenceDataService = (value) => ({ type: GET_BRANCH_CODES_REFERENCE_DATA_VALUE, value });
export const getAgentCodesReferenceDataService = (value) => ({ type: GET_AGENT_REFERENCE_DATA_VALUE, value });

// export const TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE =
// ALLSURE_INSURANCE_INSURANCE_TYPE+"toogle/privacyNotice";

export const SET_REFERENCE_DATA_VALUE = KMF_REFERENCE_DATA + 'setValue';
export const SET_REFERENCE_DATA_API_DETAILS_VALUE = KMF_REFERENCE_DATA + 'setValue/apiDetails';
// export const  tooglePrivacyNotice=(value)=>({type: TOOGLE_INSURANCE_TYPE_PRIVACY_NOTICE, value})
export const setKmfReferenceDetailsValue = (value) => ({ type: SET_REFERENCE_DATA_VALUE, value });
export const setKmfApiDetails = (value) => ({ type: SET_REFERENCE_DATA_API_DETAILS_VALUE, value });


export const KMF_APPLICATION_TOGGLE_TNC = KMF_REFERENCE_DATA + 't&C';

export const toggleTnC= (value) => ({
    type: KMF_APPLICATION_TOGGLE_TNC,
    value
});

export const KMF_APPLICATION_API_STATUS = KMF_REFERENCE_DATA + 'setApiStatus';

export const setKmfApplicationApiStatus = (value) => ({
    type: KMF_APPLICATION_API_STATUS,
    value
});

export const SET_PURCHASE_RESPONSE = KMF_REFERENCE_DATA + 'setPurchaseResponse';

export const setPurchaseServiceResponse = (value) => ({
    type: SET_PURCHASE_RESPONSE,
    value
});

export const SET_QUOTE_RESPONSE = KMF_REFERENCE_DATA + 'setQuoteResponse';

export const setQuoteServiceResponse = (value) => ({
    type: SET_QUOTE_RESPONSE,
    value
});